import { render, staticRenderFns } from "./PendencyMomentXForm.vue?vue&type=template&id=db1f51ee&scoped=true"
import script from "./PendencyMomentXForm.vue?vue&type=script&lang=js"
export * from "./PendencyMomentXForm.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_appointment-report.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./PendencyMomentXForm.vue?vue&type=style&index=1&id=db1f51ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1f51ee",
  null
  
)

export default component.exports